import { render, staticRenderFns } from "./GeneralComments.vue?vue&type=template&id=4767b56f&scoped=true"
import script from "./GeneralComments.vue?vue&type=script&lang=js"
export * from "./GeneralComments.vue?vue&type=script&lang=js"
import style0 from "./GeneralComments.vue?vue&type=style&index=0&id=4767b56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4767b56f",
  null
  
)

export default component.exports